import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import DayCell from "./DayCell";
import * as dateFns from "date-fns";

const CalendarGrid = ({ onDayClick, attendanceStatus, lockDateRecords, yearMonth }) => {

  const lockDateData = lockDateRecords?.payrollMonth
  // const startDate = lockDateData?.startDate ? new Date(lockDateData.startDate) : null;
  // const endDate = lockDateData?.endDate ? new Date(lockDateData.endDate) : null;

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    if (lockDateData) {
      const { startDate: rawStartDate, endDate: rawEndDate } = lockDateData;

      if (rawStartDate && rawEndDate) {
        setStartDate(new Date(rawStartDate));
        setEndDate(new Date(rawEndDate));
        return;
      }
    }

    // Fallback if payrollMonth is missing
    const [month, year] = yearMonth.split("-"); // e.g., "04-2025" → ["04", "2025"]
    const selectedDate = new Date(`${year}-${month}-01`);

    const defaultStart = new Date(selectedDate);
    defaultStart.setMonth(defaultStart.getMonth() - 1); // Previous month
    defaultStart.setDate(25);

    const defaultEnd = new Date(selectedDate);
    defaultEnd.setDate(24);

    setStartDate(defaultStart);
    setEndDate(defaultEnd);
  }, [lockDateRecords, yearMonth]);

  // Get the day of the week for the start date
  const startDayOfWeek = dateFns.getDay(startDate);

  const days = [];
  let day = dateFns.subDays(startDate, startDayOfWeek); // Start from the previous Sunday

  // Generate all days needed for the calendar grid
  while (day <= dateFns.addDays(endDate, 6 - dateFns.getDay(endDate))) {
    days.push(day);
    day = dateFns.addDays(day, 1);
  }

  return (
    <Box sx={{ display: "flex", width: "100%" }}>
      <Grid container direction="column" spacing={0} sx={{ flex: 1 }}>
        {/* Day Labels */}
        <Grid container item spacing={0} sx={{ borderRadius: "8px 8px 0 0" }}>
          {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((dayName) => (
            <Grid
              item
              xs
              key={dayName}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "8px",
                border: "1px solid #E9E9E9",
                p: 1,
                boxSizing: "border-box",
              }}
              fontSize={16}
              fontWeight={700}
              lineHeight={"19px"}
            >
              {dayName}
            </Grid>
          ))}
        </Grid>

        {/* Days Grid */}
        <Grid container spacing={0}>
          {days.map((day, index) => {
            const isDisabled = day < startDate || day > endDate;
            const isCurrentMonth = day >= startDate && day <= endDate;
            const dateString = day.toISOString().split("T")[0];
            {/* const status = attendanceStatus[dateString] || "No Status"; */ }
            const status = attendanceStatus[dateString] || {};
            if (!status) return null;

            return (
              <Grid
                item
                xs={12 / 7}
                key={index}
                sx={{
                  borderRadius: "8px",
                  border: "1px solid",
                  borderColor: "#E9E9E9",
                  p: 1,
                  boxSizing: "border-box",
                  height: "120px",
                  // backgroundColor: backgroundColor, 
                  // backgroundColor: isDisabled ? "#f5f5f5" : "white",
                  "&:hover": {
                    // backgroundColor: isDisabled ? "#f5f5f5" : "#f0f0f0",
                  },
                  "&:nth-of-type(7n+1)": {
                    borderLeft: "2px solid #E9E9E9", // Optional: make week separators thicker
                  },
                }}
              >
                <DayCell
                  day={day}
                  isToday={day.toDateString() === new Date().toDateString()}
                  onClick={isCurrentMonth ? onDayClick : undefined} // Only allow click if the day is in the current month
                  disabled={isDisabled}
                  // status={status} // Pass the status to DayCell
                  attendanceData={status.attendanceData || ""} // Pass attendanceData
                  regularizationData={status.regularizationData || ""} // Pass regularizationData
                  leaveData={status.leaveData || ""}
                  shiftData={status.shiftData || ""}
                />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Box>
  );
};

export default CalendarGrid;
